import { defineComponent } from '@vue/composition-api';
import throttle from 'lodash/throttle';
export default defineComponent({
  components: {},
  props: {
    disable: {
      type: Boolean,
      defatult: false
    },
    animation: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(props, ctx) {
    var handleClick = throttle(function () {
      ctx.emit('click');
    }, 500);
    return {
      handleClick: handleClick
    };
  }
});